import { render } from "./TechnicalSkillsComponent.vue?vue&type=template&id=1f925908"
import script from "./TechnicalSkillsComponent.vue?vue&type=script&lang=js"
export * from "./TechnicalSkillsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__